<template>
  <img alt="alert"  v-tooltip="alertText" :src="require('@/assets/img/icons/icon-alert.svg')">
</template>

<script>
export default {
  name: 'AlertDisplay',
  props: {
    alertText: {
      type: String,
      required: true
    }
  }
}
</script>
